module.exports = __webpack_public_path__ + "static/img/分类图片1@3x.6789466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/分类图片1@3x.png
// module id = AMMb
// module chunks = 192